export const LOADING_TEXT = 'Loading program data...'
export const TAB_TITLE = 'Lessons'
